import { Types } from 'service-api'
import type { TBookingContext, TBookingGroup, TCartGroup } from '@providers/booking/booking'
import { TShowOffersResultsPetGroup } from './booking_groups.d'
import { requiresWeightForSpecie } from './service_types'
import cloneDeep from 'lodash.clonedeep'

export const pendingOfferSelection = (groups: TCartGroup[], maxLen: number, withValue: number) => {
  let idx = -1

  for (let i = 0; i < maxLen; i++) {
    if (i !== withValue && !groups[i]?.offerSelected) {
      idx = i
      break
    }
  }
  return idx
}

export const joinPetNames = (groups?: TBookingGroup[], withTemperTest = false) => {
  return (
    groups?.map((group) =>
      group.pets
        .reduce((acc, pet) => {
          if (withTemperTest) {
            if (!pet.temperTested) {
              acc.push(pet.name)
            }
          } else {
            acc.push(pet.name)
          }
          return acc
        }, [] as string[])
        .join(', ')
    ) || []
  )
}

export const buildPetTabGroups = (groups: TBookingGroup[]) => {
  return joinPetNames(groups).map((pet) => ({ label: pet }))
}

export const sortOrders = (original: Types.BookingSearchClientDto[]) => {
  const offers: Types.BookingSearchClientDto[] = cloneDeep(original)

  offers.sort((offerA, offerB) => {
    // if group is empty move it to the end
    const aGroup = offerA.offer!.group ? offerA.offer!.group : 'ZZZZZZZZZZ'
    const bGroup = offerB.offer!.group ? offerB.offer!.group : 'ZZZZZZZZZZ'
    const aName = `${aGroup}${String(offerA.offer!.order || 0).padStart(3, '0')}`
    const bName = `${bGroup}${String(offerB.offer!.order || 0).padStart(3, '0')}`

    return aName.localeCompare(bName)
  })

  return offers
}

export const buildPetGroups = (ctx: TBookingContext, isAddOnSearch?: boolean): TShowOffersResultsPetGroup[] => {
  const groups = ctx.groups
  const wfs = requiresWeightForSpecie(ctx.config?.booking)
  const rc = [] as TShowOffersResultsPetGroup[]
  groups.forEach((group, index) => {
    rc.push({
      locationSpecies: group.specieId,
      petCount: group.pets.length,
      petWeights: group.pets
        .map(({ weight }) => (wfs[group.specieId] ? parseInt(weight) : undefined))
        .filter(Boolean) as number[],
      temperTested: group.pets.map(({ temperTested }) => temperTested),
      parentOffer: isAddOnSearch ? ctx.cart?.groups?.[index]?.offerSelected?.offer?.id : undefined,
    })
  })
  return rc
}

export const buildPetGroupsTempered = (ctx: TBookingContext): TShowOffersResultsPetGroup[] => {
  return ctx.groups.reduce((acc, group) => {
    if (group.specieName !== 'dog') {
      return acc
    }
    const localPets = group.pets.filter((pet) => !pet.temperTested)
    acc[0] =
      acc[0] ||
      ({
        locationSpecies: group.specieId,
        petCount: 0,
        petWeights: [],
        temperTested: [],
        parentOffer: undefined,
      } as TShowOffersResultsPetGroup)
    acc[0].petCount += localPets.length
    acc[0].petWeights = acc[0].petWeights?.concat(localPets.map(({ weight }) => parseInt(weight)))
    acc[0].temperTested = acc[0].temperTested?.concat(new Array(localPets.length).fill(false))

    return acc
  }, [] as TShowOffersResultsPetGroup[])
}
